export default "__VITE_ASSET__DHmDaTp2__"